import type Phaser from "phaser";
import { DEPTH } from "../objects/depthLayers.js";
import type { GameviewBackgroundRect } from "./gameviewLayout.js";

const FAR_SCROLL_PX_PER_SEC = 12;
const NEAR_SCROLL_PX_PER_SEC = 34;
const NEAR_TILE_SCALE = 1.55;
const NEAR_ALPHA = 0.38;

export class GameviewScrollingBackground {
  private readonly far: Phaser.GameObjects.TileSprite;
  private readonly near: Phaser.GameObjects.TileSprite;
  private enabled = true;

  constructor(scene: Phaser.Scene, rect: GameviewBackgroundRect, textureKey: string) {
    this.far = scene.add
      .tileSprite(rect.x, rect.y, rect.width, rect.height, textureKey)
      .setOrigin(0, 0)
      .setDepth(DEPTH.backgroundFar);
    this.near = scene.add
      .tileSprite(rect.x, rect.y, rect.width, rect.height, textureKey)
      .setOrigin(0, 0)
      .setAlpha(NEAR_ALPHA)
      .setDepth(DEPTH.backgroundNear);
    this.near.setTileScale(NEAR_TILE_SCALE, NEAR_TILE_SCALE);
  }

  setTexture(textureKey: string): void {
    if (this.far.texture.key === textureKey) return;
    this.far.setTexture(textureKey);
    this.near.setTexture(textureKey);
  }

  setEnabled(enabled: boolean): void {
    if (this.enabled === enabled) return;
    this.enabled = enabled;
    this.far.setVisible(enabled).setActive(enabled);
    this.near.setVisible(enabled).setActive(enabled);
  }

  resize(width: number, height: number): void {
    this.far.setSize(width, height);
    this.near.setSize(width, height);
  }

  update(deltaMs: number): void {
    if (!this.enabled) return;
    const deltaSeconds = Math.max(0, deltaMs) / 1000;
    this.far.tilePositionY -= FAR_SCROLL_PX_PER_SEC * deltaSeconds;
    this.near.tilePositionY -= NEAR_SCROLL_PX_PER_SEC * deltaSeconds;
  }
}
